import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-77f9adc0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "date6"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "p3"
}, "时间计算", -1));
const _hoisted_3 = {
  class: "date1"
};
const _hoisted_4 = {
  class: "date2"
};
const _hoisted_5 = {
  class: "date3"
};
const _hoisted_6 = {
  class: "date3"
};
const _hoisted_7 = {
  class: "p4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createBlock(_component_el_config_provider, {
    class: "date6",
    locale: $setup.locale
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_date_picker, {
      modelValue: $setup.value1,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.value1 = $event),
      type: "date",
      placeholder: "初始时间"
    }, null, 8, ["modelValue"])]), _createElementVNode("span", _hoisted_5, [_createVNode(_component_el_date_picker, {
      modelValue: $setup.value2,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.value2 = $event),
      type: "date",
      placeholder: "结束时间"
    }, null, 8, ["modelValue"])]), _createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
      class: "time2",
      onClick: $setup.time2,
      type: "success"
    }, {
      default: _withCtx(() => [_createTextVNode("点 击 计 算")]),
      _: 1
    }, 8, ["onClick"])])]), _createElementVNode("p", _hoisted_7, _toDisplayString($setup.time1) + "天", 1)])]),
    _: 1
  }, 8, ["locale"]);
}